import type { ReactElement } from 'react';
import { Button, Modal } from '@hotjar/hotsauce';
import { EngageTerms } from '@hotjar/engage-insights-mfe';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { ModalBody } from './styles';

export const EngageTCModal = ({
  isOpen,
  onClose,
  onSubmit,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (result: boolean) => void;
}): ReactElement => {
  const { t } = useTranslationWithPrefix('auth:engage:tc-modal');

  return (
    <Modal contentLabel={t('title')} isOpen={isOpen} onClose={onClose} size="l">
      <Modal.Header title={t('title')} />
      <ModalBody>
        <EngageTerms />
      </ModalBody>
      <Modal.Footer>
        <Button kind="ghost" onClick={onClose}>
          Cancel
        </Button>
        <Button kind="primary" onClick={() => onSubmit(true)}>
          Accept terms and continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
